import Typography from "@material-ui/core/Typography"
import React from "react"
import { useSelector } from "react-redux"
import TgLogo from "src/assets/img/LOGOYTEXTO.svg"
import Logo from "src/components/Common/Logo"
import Account from "src/components/Topbar/Account"
import ConjuntosSelect from "src/components/Topbar/ConjuntosSelect"
import { canSwitchComplex } from "src/navigation"
import { selectRol } from "src/redux/slices/authSlice"
import { selectConjunto } from "src/redux/slices/complexSlice"

export const Brand = () => {
  const conjunto = useSelector(selectConjunto)
  return <Logo img={conjunto?.Imagen || TgLogo} />
}

export const ComplexSwitcher = () => {
  const rol = useSelector(selectRol)
  if (!canSwitchComplex(rol)) return null
  return <ConjuntosSelect />
}

export const GaritaLabel = () => {
  const selectGaritaValue = useSelector(state => state.complex.selectGarita)
  if (!selectGaritaValue) return null
  return (
    <Typography color="primary" className="px-2">
      Garita: {selectGaritaValue}
    </Typography>
  )
}

export const DefaultEnd = () => (
  <>
    <ComplexSwitcher />
    <Account />
  </>
)

export const EmptyEffects = () => null
